import React, { useContext, useState, useEffect } from "react";
import {
  Tab,
  Form,
  FormGroup,
  Input,
  TextArea,
  Grid,
  Label,
  Container
} from "semantic-ui-react";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import UserAuthStore from "../../../../app/stores/userauthStore"
import { observer } from "mobx-react-lite";
import { IWorkorder } from "../../../../app/models/workorder";
import WorkOrderSORSGrid from "../wo_sor_grid/WorkOrderSORSGrid";
import WorkOrderEngineerNotes from "../wo_engineer_notes/WorkOrderEngineerNotes";
import WorkOrderVarHistory from "../wo_varhistory/WorkOrderVarHistoryOne";
import WorkOrderVariations from "../wo_variations/WorkOrderVariations";
import AppointmentGrid from "../wo_appointments/AppointmentGridOne";
import oneOrderStore from "../../../../app/stores/oneOrderStore";
import WorkOrderVariationsOne from "../wo_variations/WorkOrderVariationsOne";
import WorkOrderSORSGridOne from "../wo_sor_grid/WorkOrderSORSGridOne";
import WorkOrderEngineerNotesOne from "../wo_engineer_notes/WorkOrderEngineerNotesOne";
import LewishamDocuments from "../lewisham/LewishamDocuments";

//ADD230608 - check document tab
import WorkOrderDocumentGrid from "../wo_document_grid/WorkOrderDocumentGrid";
//ADD230614 - check clientnote tab
import WorkOrderClientnoteGrid from "../wo_clientnote_grid/WorkOrderClientnoteGrid";

//ADD220822 - set config data and var
import Axios from 'axios'
import config from '../../../../app/api/apiconfig';

const integtokenUrl = config.app.integtokenUrl
const getinvoicebaseUrl = config.app.getinvoiceguidUrl
const getinvoicedownloadUrl = config.app.getinvoicedownloadUrl
let invoiceid = ''
let invoicejobnum = ''
let loadedjobnum = ''

interface IProps {}

const getWoClaim = (cause,value) => {
  if(cause = "PPP"){
    return value - 500;
  }else{
    return 0;
  }
}

//ADD220822 - Invoice button for download invoice
export const InvButton = (Props) => {
  const defbtntext = 'Download Invoice PDF'
  const [disabled, setDisabled] = useState(false)
  const [btntext, setBtntext] = useState(defbtntext)
  //reset button if selected another job
  if (loadedjobnum !== Props.amount){
    setDisabled(false);
    setBtntext(defbtntext);
    loadedjobnum = Props.amount;
  }
  //download invoice
  function handleClickDownload(){
    console.log('invoiceid:', invoiceid)
    var answer = window.confirm("Do you want to download the invoice file?")
    if(answer){
      setDisabled(true);
      var url = getinvoicedownloadUrl + invoiceid;
      console.log('url:', url)
      if (getinvoicedownloadUrl.length < 5 || invoiceid.length < 5) {
        setBtntext('Download Request Invalid, please retry later.');  
      }
      else {
        setBtntext('Downloading PDF...');
        Axios({
          url: url,
          method: 'GET',
          responseType: 'blob', 
        }).then((response) => {
          const url2 = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url2;
          const file = invoicejobnum + '.pdf'
          link.setAttribute('download', file); 
          document.body.appendChild(link);
          link.click();
          setBtntext('Invoice Downloaded');
          //setDisabled(false);
          
        }).catch((error) =>{
          setBtntext('Download PDF Error, please retry later.');
          console.log('Error:',error)
        });
      }
    }
  }
  return (
      <div>
        <button className='ui mini fluid button' disabled={disabled} onClick={handleClickDownload}>
        <i className="download icon"></i>
        {btntext}
        </button>
      </div>
  )
}


const getPanes = (wo: IWorkorder) => {
  return [
    {
      menuItem: "Details",
      render: () => (
        <Tab.Pane attached={false}>
          <Container>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Form widths="equal">
                    <FormGroup>
                      <Form.Field>
                        <Input
                          value={wo.JobNo}
                          label="Job No"
                          size="mini"
                          readOnly
                          placeholder="Job No"
                          fluid
                        />
                      </Form.Field>
                      <Form.Field>
                        <Input
                          value={wo.ClientRef}
                          label="Client Ref"
                          size="mini"
                          readOnly
                          placeholder="Client Ref"
                          fluid
                        />
                      </Form.Field>
                    </FormGroup>

                    <FormGroup>
                      {/* <Form.Field>
                        <Input
                          value={wo.JobStatus}
                          label="Status"
                          size="mini"
                          readonly
                          placeholder="Status"
                          fluid
                        />
                      </Form.Field> */}
                      <Form.Field>
                        <Input
                          value={wo.JobSubStatus}
                          label="Sub Status"
                          size="mini"
                          readOnly
                          placeholder="Sub Status"
                          fluid
                        />
                      </Form.Field>
                    </FormGroup>
                    <FormGroup>
                      <Form.Field>
                        <Input
                          label="Priority"
                          value={wo.Priority}
                          size="mini"
                          readOnly
                          placeholder="Priority"
                          fluid
                        />
                      </Form.Field>
                      <Form.Field>
                        <Input
                          fluid
                          label="Value"
                          readOnly
                          size="mini"
                          value={wo.JobValue}
                          placeholder="Value"
                        />
                      </Form.Field>
                    </FormGroup>
                    <FormGroup>
                        <Form.Field>
                          <Input
                            label="Date Raised"
                            value={wo.DateRaised}
                            size="mini"
                            readOnly
                            placeholder="Date Raised"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                    <FormGroup>
                        <Form.Field>
                          <Input
                            label="WO Claim"
                            value={x => getWoClaim(wo.Cause,wo.JobValue)}
                            size="mini"
                            readOnly
                            placeholder="Claim"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                    <FormGroup>
                        <Form.Field>
                          <Input
                            label="Cause"
                            value={wo.Cause}
                            size="mini"
                            readOnly
                            placeholder="Cause"
                            fluid
                          />
                        </Form.Field>
                  
                      </FormGroup>
                    <FormGroup>
                      <Form.Field>
                        <Label>Site Address</Label>
                        <TextArea readOnly value={wo.Address} />
                      </Form.Field>
                    </FormGroup>
                  </Form>
                </Grid.Column>
                <Grid.Column>
                  <Form widths="equal">
                    <FormGroup>
                      <Form.Field>
                        <Label>Job Summary</Label>
                        <TextArea readOnly rows="10" value={wo.JobSummary} />
                      </Form.Field>
                    </FormGroup>
                    <FormGroup>
                        <Form.Field>
                          <Input
                            label="Job Created On"
                            value={wo.CreatedOn}
                            size="mini"
                            readOnly
                            placeholder="Job Create On"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                      <InvButton amount={invoicejobnum}></InvButton>
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Tab.Pane>
      )
    },
    {
      menuItem: "SORS",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderSORSGridOne />
        </Tab.Pane>
      )
    },
    {
      menuItem: "Engineer Notes",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderEngineerNotesOne  />
        </Tab.Pane>
      )
      },
    {
      menuItem: "Variation History",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderVarHistory />
        </Tab.Pane>
      )
    },

    {
      menuItem: "Variation Request",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderVariationsOne />
        </Tab.Pane>
      )
    },
    {
      menuItem: "Appointments",
      render: () => (
        <Tab.Pane attached={false}>
          <AppointmentGrid/>
        </Tab.Pane>
      )
    }, 



  ];
};

const panes = [
  {
    menuItem: "Details",
    render: () => (
      <Tab.Pane attached={false}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Job No"
                      size="mini"
                      placeholder="Job No"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      label="Client Ref"
                      size="mini"
                      placeholder="Client Ref"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>

                <FormGroup>
                  {/* <Form.Field>
                    <Input
                      label="Status"
                      size="mini"
                      placeholder="Status"
                      fluid
                    />
                  </Form.Field> */}
                  <Form.Field>
                    <Input
                      label="Sub Status"
                      size="mini"
                      placeholder="Sub Status"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Priority"
                      size="mini"
                      placeholder="Priority"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      fluid
                      label="Value"
                      size="mini"
                      placeholder="Value"
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Label>Site Address</Label>
                    <TextArea />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Label>Job Summary</Label>
                    <TextArea rows="10" />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Tab.Pane>
    )
  },
  {
    menuItem: "SORS",
    render: () => <Tab.Pane attached={false}>SORS</Tab.Pane>
  },
  {
    menuItem: "Engineer Notes",
    render: () => <Tab.Pane attached={false}>Engineer Notes</Tab.Pane>
  },
  {
    menuItem: "Variation History",
    render: () => <Tab.Pane attached={false}>Variation History</Tab.Pane>
  }
  ,
  {
    menuItem: "Appointments",
    render: () => <Tab.Pane attached={false}>Appointments</Tab.Pane>
  }
  ,
  
];

const lewishamMOTPanes = [
  {
    menuItem: "Details",
    render: () => (
      <Tab.Pane attached={false}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Job No"
                      size="mini"
                      placeholder="Job No"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      label="Client Ref"
                      size="mini"
                      placeholder="Client Ref"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>

                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Status"
                      size="mini"
                      placeholder="Status"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      label="Sub Status"
                      size="mini"
                      placeholder="Sub Status"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Priority"
                      size="mini"
                      placeholder="Priority"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      fluid
                      label="Value"
                      size="mini"
                      placeholder="Value"
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Label>Site Address</Label>
                    <TextArea />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Label>Job Summary</Label>
                    <TextArea rows="10" />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Tab.Pane>
    )
  },
  {
    menuItem: "SORS",
    render: () => <Tab.Pane attached={false}>SORS</Tab.Pane>
  },
  // {
  //   menuItem: "Engineer Notes",
  //   render: () => <Tab.Pane attached={false}>Engineer Notes</Tab.Pane>
  // },
  {
    menuItem: "Variation History",
    render: () => <Tab.Pane attached={false}>Variation History</Tab.Pane>
  },

  {
    menuItem: "Appointments",
    render: () => <Tab.Pane attached={false}>Appointments</Tab.Pane>
  },


 
  
];

//ADD 230608 for origin document tab
const getOriginPanes = (wo: IWorkorder) => {
  var OriginPanes = getPanes(wo)
  OriginPanes.push({
    menuItem: "Documents",
    render: () => (
       <Tab.Pane attached={false}><WorkOrderDocumentGrid  /></Tab.Pane>
     )
     });
  OriginPanes.push({
    menuItem: "Notes",
    render: () => (
        <Tab.Pane attached={false}><WorkOrderClientnoteGrid  /></Tab.Pane>
     )
     });    
  return OriginPanes;
  };

//ADD 251030 for peabody document tab
const getPeabodyPanes = (wo: IWorkorder) => {
  var PeabodyPanes = getPanes(wo)
  PeabodyPanes.push({
    menuItem: "Documents",
    render: () => (
       <Tab.Pane attached={false}><WorkOrderDocumentGrid  /></Tab.Pane>
     )
     });
  
  return PeabodyPanes;
  };

//ADD 230608 for origin document tab
var OriginPanes = panes
OriginPanes.push({
  menuItem: "Documents",
  render: () => <Tab.Pane attached={false}>Documents</Tab.Pane>
});
OriginPanes.push({
  menuItem: "Notes",
  render: () => <Tab.Pane attached={false}>Notes</Tab.Pane>
});

//ADD 251030 for peabody document tab
const PeabodyPanes = panes

const WorkOrderDetails: React.FC<IProps> = () => {
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 

  const userauthStore = useContext(UserAuthStore);
  const workorderStore = useContext(oneOrderStore);

  const { selectedWorkOrder: workorder } = workorderStore;
  const [tabContent, setTabContent] = useState([{}]);
  let validToken = ""

  //ADD220822 - for the method to get dyna token 
  function getintegtoken(){
  console.log ("getintegtokenUrl:", integtokenUrl)
    Axios.get(integtokenUrl).then(response => {
        if(response.status === 200){
          var responsedata = response.data;
          if (responsedata != null && responsedata.length > 9) {
            validToken = responsedata
            sessionStorage.setItem('token', responsedata)
          }
        }
    });
  }
  //ADD220822 - for the retrieve of invoice guid thru dynamic
  function getInvoiceId(jobId:string,jobNum:string) {
  try
  {
    if (sessionStorage.getItem("token")){
      validToken = sessionStorage.getItem("token")
    } else{
      getintegtoken()
      validToken = sessionStorage.getItem("token")
    }
    
    let thisfilter = ""
    if (jobId.length > 9){
      thisfilter = "(" + jobId + ")?$select=msdyn_name,_gilm_currentinvoice_value,gilm_clientref"
    }
    else{
      console.log('JobId-invalid')
      return 
    }
    let geturl = getinvoicebaseUrl + "" + thisfilter
    let config  = {
      headers: {
        'Authorization': 'Bearer ' + validToken
      }
    }
    invoicejobnum = 'INV_' + jobNum
    //console.log(invoicejobnum, geturl)
    Axios.get(geturl, config)
      .then(response => {
          if(response.status === 200){
            var getvalue = response.data._gilm_currentinvoice_value;
            console.log('get1st',getvalue);
            if (getvalue == null || getvalue.length < 2){
              getvalue = " "
              invoiceid = getvalue
              return getvalue
            }
            else{
              invoiceid = getvalue
              return getvalue
            }
          }
          else{
            console.log('response',response);
          }
      }).catch((error) =>{
        if (error.response && error.response.status === 401) {
            console.log('TokenError',error.response)
            getintegtoken()
            validToken = sessionStorage.getItem("token")
            config  = {
              headers: {
                'Authorization': 'Bearer ' + validToken
              }
            }
            Axios.get(geturl, config).then(response => {
            if(response.status === 200){
              var getvalue = response.data._gilm_currentinvoice_value;
              console.log('get2nd',getvalue);
              if (getvalue == null){
                getvalue = " "
                invoiceid = getvalue
                return getvalue
              }
              else{
                invoiceid = getvalue
                return getvalue
              }
            }
            })

        }
      })
    }
    catch(ex){
      console.error("An error has occurred on getInvoiceId: " + ex)
    }
    return
  }


  useEffect(() => {
    userauthStore.HydrateAuthState();
   }, [userauthStore]);
 

   useEffect(() => {
    var cli = sessionObj.Client.Name;
    console.log('client',cli )
    if (workorder != null) 
    {
      getInvoiceId(workorder.JobId, workorder.JobNo);
      //CHANGE 230608 for origin document tab
      if(cli == "Origin Housing" || cli == "Origin"){
        setTabContent(getOriginPanes(workorder));
      } else if(cli == "Peabody New Contract 2024" || cli == "Peabody"){
        //ADD 251030 for peabody document tab
        setTabContent(getPeabodyPanes(workorder))
      } else{
        setTabContent(getPanes(workorder));
      }
    } 
    else
    {
      //CHANGE 230608 for origin document tab
      if(cli == "Origin Housing" || cli == "Origin"){
        setTabContent(OriginPanes)
      } else if(cli == "Peabody New Contract 2024" || cli == "Peabody"){
        //ADD 251030 for peabody document tab
        setTabContent(PeabodyPanes)
      } else if(cli == "Lewisham MOT"){
        setTabContent(lewishamMOTPanes)
      } else {
        setTabContent(panes)
      }
    }
  }, [workorder]);

  return (
    <div>
      <Tab
        menu={{ fluid: true, vertical: true, tabular: false }}
        panes={tabContent}
      />
    </div>
  );
};

export default observer(WorkOrderDetails);
